import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { IFreightBasicForCarrier } from '@okcargo-apps/shared-domain';
import { AnalyticsService } from '@okcargo-apps/shared-infrastructure-ionic';
import { QrHelpModalComponent } from '../qr-help-modal/qr-help-modal.component';

@Component({
  selector: 'lib-qr-modal',
  templateUrl: './qr-modal.component.html',
  styleUrls: ['./qr-modal.component.scss'],
  imports: [IonContent, IonTitle, IonIcon, IonButton, IonButtons, IonToolbar, IonHeader],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrModalComponent implements OnInit {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly modalCtrl = inject(ModalController);
  private readonly analyticsService = inject(AnalyticsService);

  // comes form the component that opens the modal
  public freight!: IFreightBasicForCarrier;

  protected safeQrSvg: SafeHtml | null = null;

  ngOnInit(): void {
    const rawSvg = this.freight?.qrSvg;

    if (rawSvg) {
      this.safeQrSvg = this.sanitizer.bypassSecurityTrustHtml(rawSvg);
    }

    this.analyticsService.logEvent('deca_qr_view');
  }

  protected async showQrHelp(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: QrHelpModalComponent,
      componentProps: {},
    });
    modal.present();
  }

  protected async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
